import React from 'react';
import {Flex} from "reflexbox";
import CardHeader from "@mui/material/CardHeader";
import Avatar from "@mui/material/Avatar";

const LocationHeader = (props) => {

  let avatar = "?";
  let title = "Unknown Location";
  if (props.location) {
    avatar = (<img alt={'location'} src={props.location.img} style={{height: '100%'}}/>);
    title = (<>
      <Flex style={{justifyContent: 'space-between'}}>
        <Flex>
          {props.location.name}
        </Flex>
        <Flex style={{minWidth: '48px', justifyContent: 'center'}}>
          {props.additionalTitle}
        </Flex>
      </Flex>
    </>);
  }

  return (<CardHeader
    avatar={
      <Avatar aria-label="location-profile">
        {avatar}
      </Avatar>
    }
    title={title}
    subheader={props.subheader || null}
  />)
};

export default LocationHeader;